<template>
  <div>
    <v-layout wrap class="mb-4">
      <v-flex xs9>
        <h3 class="headline mt-0">
          <img src="/static/img/packhai.png.webp" alt style="max-height: 50px" />
        </h3>
      </v-flex>
      <v-flex xs3 class="text-xs-right">
        <template v-if="check_privilege('packhai')">
          <v-btn fab outline small color="primary" v-if="!isEdit" @click="editSetting">
            <v-icon>edit</v-icon>
          </v-btn>
        </template>
        <template v-else>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn readonly fab outline small color="grey" v-on="on">
                <v-icon>lock</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Upgrade to {package} Plan', { package: $t('PREMIUM') }) }}</span>
          </v-tooltip>
        </template>
      </v-flex>
    </v-layout>
    <div v-if="loading" class="spinner text-xs-center">
      <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
    </div>

    <div v-else>
      <v-stepper v-model="step" vertical class="elevation-0">
        <v-stepper-step step="1" :complete="step > 1">
          {{ $t('Register Packhai') }}
        </v-stepper-step>
        <v-stepper-content step="1">
          <div>{{ $t('Connect with Packhai service with more convenient delivery.') }}</div>
          <v-btn
            depressed
            color="primary"
            :href="'https://shop.packhai.com/register'"
            target="_blank"
            @click="step = 2"
            >{{ $t('Register Packhai') }}</v-btn
          >

          <v-btn flat @click="step = 2">
            {{ $t('already_have_an_account') }}
          </v-btn>
          <div>
            <a href="https://blog.zwiz.app/packhai/" target="_blank">{{
              $t('How to use Packhai')
            }}</a>
          </div>
        </v-stepper-content>
        <v-stepper-step step="2" :complete="step > 2">
          {{ $t('Connect Packhai to Zwiz') }}
        </v-stepper-step>
        <v-stepper-content step="2">
          <div
            class="pa-2"
            style="position: relative; "
            :style="{ 'min-height': !check_privilege('packhai') ? '300px' : '' }"
          >
            <v-premium-plan-popup
              v-if="!check_privilege('packhai')"
              type="premium"
              text="Upgrade to premium, starting at 500 baht / month to connect ZWIZ with PACKHAI Upgrade now."
            ></v-premium-plan-popup>
            <div class="mb-2" v-if="showCancel">
              <div>
                {{ $t('Enable/Disable Packhai') }}
              </div>
              <div>
                <toggle-button
                  class="mt-2"
                  :value="setting.status"
                  :sync="true"
                  :color="$vuetify.theme.success"
                  @change="toggleStatus"
                  :labels="{ checked: 'ON', unchecked: 'OFF' }"
                  style="display: inline-block"
                />
              </div>
            </div>

            <template v-if="!showCancel">{{
              $t('After receiving confirmation from Packhai')
            }}</template>
            <div class="caption">Packhai Token</div>
            <div class="form-control" :class="{ 'has-error': errors.has('token') }">
              <template v-if="isEdit">
                <input
                  type="text"
                  v-model="setting.token"
                  v-validate="'required'"
                  name="setting.token"
                  data-vv-as="Packhai Token"
                />
                <span style="color:red" class="text-error" v-if="errors.has('setting.token')">{{
                  errors.first('setting.token')
                }}</span>
              </template>
              <div class="primary--text" v-else>
                {{ setting.token ? setting.token : '-' }}
              </div>
            </div>

            <div class="text-xs-center" v-if="isEdit">
              <v-btn color="grey" outline @click="onCancel">
                {{ $t('cancel') }}
              </v-btn>
              <v-btn color="primary" depressed @click="onSave">
                {{ $t('Save') }}
              </v-btn>
            </div>
          </div>
        </v-stepper-content>
      </v-stepper>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import { cloneDeep } from 'lodash'
import { ToggleButton } from 'vue-js-toggle-button'
export default {
  components: {
    ToggleButton
  },
  data() {
    return {
      isEdit: false,

      loading: false,
      setting: {
        token: null,
        status: false
      },
      showCancel: true,
      step: 1
    }
  },
  async mounted() {
    this.loading = true
    this.setting = {
      token: this.selectedBot.packhai_token || null,
      status: this.selectedBot.packhai_status || null
    }
    await this.$nextTick()
    if (this.setting.token == null) {
      this.editSetting()
      this.showCancel = false
    } else {
      this.step = 2
    }
    this.loading = false
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  methods: {
    async toggleStatus() {
      const status = !this.setting.status
      try {
        await api.post_packhai_save_token({
          params: {
            pageid: this.selectedBot.pageid
          },
          body: {
            packhai_status: status,
            packhai_token: this.setting.token
          }
        })
        await this.$store.dispatch('updateBotDetail')
        this.setting.status = status
      } catch (error) {
        console.log(error)
      }
    },
    editSetting() {
      this.isEdit = true
      this.cached_setting = cloneDeep(this.setting)
    },
    onCancel() {
      this.isEdit = false
      this.setting = cloneDeep(this.cached_setting)
    },

    async onSave() {
      if (!this.check_privilege('packhai')) return false
      try {
        if (this.setting.token != null && this.setting.status == null) this.setting.status = true
        var result = await this.$validator.validateAll()
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }

        await api.post_packhai_save_token({
          params: {
            pageid: this.selectedBot.pageid
          },
          body: {
            packhai_status: this.setting.status,
            packhai_token: this.setting.token
          }
        })
        await this.$store.dispatch('updateBotDetail')

        await this.$swal.fire({
          title: this.$t('Successfully'),
          type: 'success'
        })
        this.cached_setting = cloneDeep(this.setting)

        this.isEdit = false
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/PackhaiManage.vue